import actionCreatorFactory from 'typescript-fsa'

import * as t from './types'

/**
 * The action creator for this module. Note that it contains the module name.
 */
const actionCreator = actionCreatorFactory('Database')

export const databaseReady = actionCreator('DATABASE_READY')

/** Update the project details (does not include the products). */
export const updateProject = actionCreator<DeepReadonly<t.Project>>('UPDATE_PROJECT')
export type UpdateProjectAction = ReturnType<typeof updateProject>

/** Update the project details INCLUDING the products. */
export const updateWholeProject = actionCreator<t.ProjectWithProducts>('UPDATE_WHOLE_PROJECT')

/**
 * Notifies that a whole project's writes have all been queued to the local cache, and so can be read
 * back locally, even though the server may not have acknowledged them yet.
 */
export const wholeProjectQueued = actionCreator<t.ProjectID>('WHOLE_PROJECT_QUEUED')

export interface UpdateProductPayload {
	projectId: t.ProjectID
	product: DeepReadonly<t.Product>
	/** The base product state to diff against when computing the Firestore patch */
	baseProduct?: DeepReadonly<t.Product>
}
export const updateProduct = actionCreator<UpdateProductPayload>('UPDATE_PRODUCT')
export type UpdateProductAction = ReturnType<typeof updateProduct>

export interface DeleteProductPayload {
	projectId: t.ProjectID
	productId: t.ProductID
}
export const deleteProduct = actionCreator<DeleteProductPayload>('DELETE_PRODUCT')
export type DeleteProductAction = ReturnType<typeof deleteProduct>

export const undeleteProduct = actionCreator<DeleteProductPayload>('UNDELETE_PRODUCT')
export type UndeleteProductAction = ReturnType<typeof undeleteProduct>

export interface DownloadedProjectPayload {
	projectId: t.ProjectID
	/** The project details (does not include the products, which are notified individually by downloadedProduct). */
	project: t.Project
}
export const downloadedProject = actionCreator<DownloadedProjectPayload>('DOWNLOADED_PROJECT')
export type DownloadedProjectAction = ReturnType<typeof downloadedProject>

export interface DownloadedProductPayload {
	projectId: t.ProjectID
	product: t.Product
}
export const downloadedProduct = actionCreator<DownloadedProductPayload>('DOWNLOADED_PRODUCT')

export const onlineStateChange = actionCreator<boolean>('ONLINE_STATE_CHANGE')

/** Whether we are actively processing downloaded sync data. */
export const syncing = actionCreator<boolean>('SYNCING')
/** Reports the number of additional projects the sync has found to download. */
export const syncFound = actionCreator<number>('SYNC_FOUND')
/** Reports the number of additional projects processed by the sync. */
export const syncProgress = actionCreator<number>('SYNC_PROGRESS')

export interface Projects {
	[projectId: string]: t.Project
}
